function Util () {
}
//[*?.]ocn.ne.jp: www.ocn.ne.jp, www.test.ocn.ne.jp, ocn.ne.jp
//[] Simplified wildcard character to RegExp conversion (for messageId only)
Util.messageIdWildcard2RegExp = function (messageId) {

    var str = messageId.replace(/([.+\^${}()|\/\\])/g, "\\$1");

    // [
    str = str.replace(/\[/g, "(");
    // ]
    str = str.replace(/\]/g, "|)");
    // *
    str = str.replace(/\*+/g, "[a-zA-Z0-9-._]*");
    // ?
    str = str.replace(/\?/g, "[a-zA-Z0-9-_]");

    return str;
};

//[] Simplified wildcard character to RegExp conversion (for domain only)
Util.domainWildcard2RegExp = function (domain) {

    var str = domain.replace(/([.+\^${}()|\/\\])/g, "\\$1");

    // [
    str = str.replace(/\[/g, "(");
    // ]
    str = str.replace(/\]/g, "|)");
    // *
    str = str.replace(/\*+/g, "[a-zA-Z0-9-.]*");
    // ?
    str = str.replace(/\?/g, "[a-zA-Z0-9-]");

    return str;
};

Util.hasWildcard = function (str) {

    return (str.search(/[\[\]*?]/) !== -1);
};

// "?****???" -> "?*???"
Util.reduceWildcard = function (str) {

    return str.replace(/\*+/g, "*");
};

Util.reduceArray = function (array, callback, initialValue) {  
    "use strict";
    if ( null === array || "undefined" === typeof array ) {
        throw new TypeError(
            "Array.prototype.reduce called on null or undefined" );
    }
    
    if ( "function" === typeof array.reduce ) {
        return array.reduce(callback, initialValue);
    }

    if ( "function" !== typeof callback ) {
        throw new TypeError( callback + " is not a function" );
    }
    var t = Object( array ), len = t.length >>> 0, k = 0, value;
    if ( initialValue != null ) {
        value = initialValue;
    } else {
        while ( k < len && !(k in t) ) k++;
        if ( k >= len )
            throw new TypeError("Reduce of empty array with no initial value");
        value = t[ k++ ];
    }
    for ( ; k < len ; k++ ) {
        if ( k in t ) {
            value = callback( value, t[k], k, t );
        }
    }
    return value;
};

Util.getObjectType = function (obj) {
    return Object.prototype.toString.call(obj);
};

Util.getDateTimeString = function (isUTC) {
    var date = new Date();

    function pad(number) {
        if ( number < 10 ) {
            return "0" + number;
        }
        return number;
    }

    var UTCString = isUTC ? "UTC" : "";

    return date["get" + UTCString + "FullYear"]() +
        "-" + pad( date["get" + UTCString + "Month"]() + 1 ) +
        "-" + pad( date["get" + UTCString + "Date"]() ) +
        " " + pad( date["get" + UTCString + "Hours"]() ) +
        ":" + pad( date["get" + UTCString + "Minutes"]() ) +
        ":" + pad( date["get" + UTCString + "Seconds"]() );
};

Util.generateId = function (count) {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    function t8() {
        return new Date()
            .getTime()
            .toString(16)
            .slice(-8);
    }

    if (count == null) {

        count = 1;
    }

    var result = t8();

    for (var i = 0; i < count; i++) {

        result += s4();
    }

    return result;
};

Util.randomBytes = function (count, isCrypto) {

    function getRandomIntInclusive(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    if (count == null) {

        count = 1;
    }

    if (isCrypto == null) {

        isCrypto = false;
    }

    var result = "";

    var i = 0;

    if (isCrypto === true &&
        crypto != null &&
        crypto.getRandomValues != null &&
        Uint8Array != null) {

        var randomNumArray = new Uint8Array(count);
        crypto.getRandomValues(randomNumArray);

        for (i = 0; i < count; i++) {

            result += ("0" + randomNumArray[i].toString(16)).slice(-2);
        }

    } else {

        for (i = 0; i < count; i++) {

            result += getRandomIntInclusive(0x100, 0x1FF).toString(16).slice(-2);
        }
    }

    return result;
};

Util.stringReplace = function (string, object, prefix, suffix) {

    if (string == null || object == null) {

        return string;
    }

    if (prefix == null) {

        prefix = "__";
    }

    if (suffix == null) {

        suffix = "__";
    }

    var regExp = new RegExp(prefix + "([a-zA-Z0-9.]+)" + suffix, "g");

    return string.replace(regExp, function (match, p1) {

        var value = Util.reduceArray(p1.split("."), function (o, x) { return o[x]; }, object);

        if (value == null) {
            return match;
        }

        return value;
    });
};

// Only for 8 and above
Util.isIE = function () {

    var userAgent = "";

    if (window.navigator != null && window.navigator.userAgent != null) {

        userAgent = window.navigator.userAgent;
    }

    return (userAgent.search(/trident/i) !== -1);
};

// IE only, not include $version itself
Util.isDocModeBelow = function (version) {

    if (document.documentMode != null &&
        document.documentMode < version) {

        return true;
    }

    return false;
};

Util.isMobile = function(){
    return (window.navigator.userAgent.match(/PasswordManager\/[0-9.]+\s+\((iPhone|iPad|Android)/i) != null);
};

Util.isIos = function(){
    return (window.navigator.userAgent.match(/PasswordManager\/[0-9.]+\s+\((iPhone|iPad)/i) != null);
};

Util.isAndroid = function(){
    return (window.navigator.userAgent.match(/PasswordManager\/[0-9.]+\s+\(Android/i) != null);
};

Util.isPad = function(){

    
    //return (window.navigator.userAgent.match(/PasswordManager\/[0-9.]+\s+\((iPad|Android)\)/i) != null);

    var isPad = false;
    var isAndroid = Util.isAndroid();

    if (isAndroid === true) {

        isPad = (window.navigator.userAgent.match(/Mobile Safari/i) == null);

    } else {

        isPad = (window.navigator.userAgent.match(/PasswordManager\/[0-9.]+\s+\(iPad/i) != null);
    }

    return isPad;
};

var checker = "checkme";
Util.escapeReplaceValue = function (replaceValue) {

    if (checker === "checkme") {

        checker = checker.replace("checkme", function () { return "$$"; });
    }

    // Browser bug (Safari), should be "$$"
    if (checker === "$") {

        return replaceValue.replace(/\$/g, "$$$$");
    }

    return (function () {

        return replaceValue;
    });
};

Util.isWindowAvailable = function (wnd) {

    var targetWindow = null;

    // in IE, accessing window object of that frame, even just checking null or not,
    // sometimes might throw Permission Denied exception, might be caused by a closed frame
    // use === to check this
    try {

        targetWindow = (wnd === wnd) && wnd;

    } catch(e) {}

    if (targetWindow == null) {

        return false;
    }

    return true;
};

Util.isSameWindow = function (wndA, wndB) {

/*
IE:
1. invalidWindow === invalidWindow: throws Permission denied.
2. invalidWindow == invalidWindow: return true
3. invalidWindow == null: return false
4. invalidWindow == otherWindow: throws Permission defnied.
5. otherWindow == invalidWindow: throws Access is denied.
*/
    var isSameWindow = false;

    try {

        isSameWindow = (wndA == wndB);

    } catch(e) {

        /* 4, 5 */
    }

    return isSameWindow;
};

Util.stringCensoring = function (string, maxVisibleLen, maxOutputLen, censorChar) {

    if (string == null ||
        string.length == null ||
        string.length === 0) {

        return "";
    }

    var strLen = string.length;
    var resultStr = string;

    if (maxOutputLen == null ||
        maxOutputLen > strLen) {

        maxOutputLen = strLen;
    }

    if (maxVisibleLen != null &&
        maxVisibleLen >= 0) {

        if (censorChar == null) {

            censorChar = "*";
        }

        var visibleLen = Math.floor(strLen / 2);

        visibleLen = (visibleLen > maxVisibleLen) ? maxVisibleLen : visibleLen;

        var censorLen = strLen - visibleLen;

        if (censorLen > 0) {

            resultStr = resultStr.slice(0, visibleLen);

            if (censorChar.repeat != null) {

                resultStr += censorChar.repeat(censorLen);

            } else {

                resultStr += Array(censorLen + 1).join(censorChar);
            }
        }
    }

    if (maxOutputLen != strLen) {

        resultStr = resultStr.slice(0, maxOutputLen);
    }
    
    return resultStr;
};



module.exports = Util;